import { reducer as formReducer } from 'redux-form';
import { FORM_REPLACE } from '../constants/actionTypes';

function customFormReducer(state = {}, action, prevReducer) {
	const { type, payload } = action;

	switch (type) {
		case FORM_REPLACE:
			return {
				...payload.state,
			};

		default:
			return state;
	}
}

export default function reducer(state = {}, action) {
	const res = formReducer(state, action);
	const res2 = customFormReducer(res, action);
	return res2;
}



// WEBPACK FOOTER //
// ./src/reducers/form.js